import script from "./FeedbackButton.vue?vue&type=script&setup=true&lang=ts"
export * from "./FeedbackButton.vue?vue&type=script&setup=true&lang=ts"

import "./FeedbackButton.vue?vue&type=style&index=0&id=5ab6a3a6&lang=scss"

const __exports__ = script;

export default __exports__